import { useState } from "react";
import { TextareaProps } from "./types";
import { inputBase } from "../All/types";

export default function Textarea({ value, onChange, placeholder, rows = 4, maxLength }: TextareaProps) {
    const [focused, setFocused] = useState(false);
    return (
        <div style={{ position: "relative" }}>
            <textarea
                value={value} onChange={onChange} placeholder={placeholder} rows={rows} maxLength={maxLength}
                style={{
                    ...inputBase, resize: "vertical", minHeight: rows * 24, lineHeight: 1.6,
                    paddingBottom: maxLength ? 24 : 10,
                    borderColor: focused ? "var(--or)" : "var(--border)",
                    boxShadow: focused ? "0 0 0 3px rgba(191,61,12,0.10)" : "none",
                }}
                onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
            />
            {maxLength && (
                <span style={{
                    position: "absolute", right: 12, bottom: 10, fontSize: 11,
                    color: value.length > maxLength * 0.85 ? "var(--or)" : "var(--text3)", pointerEvents: "none",
                }}>{value.length}/{maxLength}</span>
            )}
        </div>
    );
}